const COMPANY_ID = 'RxXVzG';
const LIST_ID = 'WgvxMs';

const selectors = {
  form: '[data-form]',
  input: 'input',
  button: '[data-submit-button]',
  error: '[data-error]',
  success: '[data-success]',
}

class NewsletterForm extends HTMLElement {
  constructor() {
    super();

    this.onSubmit = this.onSubmit.bind(this);
  }

  hideError() {
    this.error.setAttribute('aria-hidden', true);
  }

  hideSuccess() {
    this.success.setAttribute('aria-hidden', true);
  }

  showError(message) {
    this.error.setAttribute('aria-hidden', false);
    this.error.textContent = message ?? 'Something went wrong, please try again.';
  }

  async onSubmit(event) {
    event.preventDefault();
    event.stopPropagation();

    this.hideError();
    this.hideSuccess();
    this.button.setAttribute('disabled', true);
    this.button.setAttribute('aria-busy', true);
    
    const formData = new FormData(this.form);

    const email = formData.get('email');
    const acceptsMarketing = formData.get('accepts_marketing');

    if (!email) {
      this.showError('Email is required');
      return;
    }

    if (!acceptsMarketing) {
      this.showError('You must agree to the privacy policy');
      return;
    }

    const data = {
      "data": {
        "type": "subscription",
        "attributes": {
          "profile": {
            "data": {
              "type": "profile",
              "attributes": {
                "email": email,
                "subscriptions": {
                  "email": {
                    "marketing": {
                      "consent": "SUBSCRIBED"
                    }
                  }
                }
              }
            }
          }
        },
        "relationships": {
          "list": {
            "data": {
              "type": "list",
              "id": LIST_ID
            }
          }
        }
      }
    }

    try {
      const response = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${COMPANY_ID}`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          accept: 'application/json',
          revision: '2025-10-15',
          'content-type': 'application/json',
        }
      })
      
      if (!response.ok) {
        throw new Error('Failed to subscribe to newsletter');
      }

      this.setAttribute('data-state', 'success');
    } catch (error) {
      console.log('Error message: ', error.message);
      this.showError();
    } finally {
      this.button.removeAttribute('disabled');
      this.button.removeAttribute('aria-busy');
    }
  }

  setupEventListeners() {
    this.form.addEventListener('submit', this.onSubmit);
  }

  removeEventListeners() {
    this.form.removeEventListener('submit', this.onSubmit);
  }

  connectedCallback() {
    this.form = this.querySelector(selectors.form);
    this.input = this.querySelector(selectors.input);
    this.button = this.querySelector(selectors.button);
    this.error = this.querySelector(selectors.error);
    this.success = this.querySelector(selectors.success);

    this.setupEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }
}

if (!customElements.get('newsletter-form')) {
  customElements.define('newsletter-form', NewsletterForm);
}